import Vue from 'vue'
import Router from 'vue-router'

//Make Note important:
//Terminalogy updated
//Courses -> Subjects
//Sections -> Units
//Topics -> Lessons


// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')


const AppUsers= ()=>import('@/views/myUsers/appusers')
const AppUser= () =>import('@/views/myUsers/appuser')

const CMSUsers= ()=>import('@/views/myUsers/CmsUsers')
const CMSUser= ()=>import('@/views/myUsers/CmsUser')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/auth/Login')
const Register = () => import('@/views/pages/Register')

// Users
const Users = () => import('@/views/users/Users')
const User = () => import('@/views/users/User')

const Category = () => import('@/views/Categories/category')
const Categories = () => import('@/views/Categories/categories')

const Streams = () => import('@/views/Streams/streams')
const Stream = () => import('@/views/Streams/stream')


const Grades = () => import('@/views/Grades/grades')
const Grade = () => import('@/views/Grades/grade')


const Courses = () => import('@/views/courses/Courses')
const Course = () => import('@/views/courses/Course')

const Classes = () => import('@/views/Class/classes')
const Class = () => import('@/views/Class/class')


const Units = () => import('@/views/Units/units')
const Unit = () => import('@/views/Units/unit')

const Quizs = () => import('@/views/Units/quizs')
const Quiz = () => import('@/views/Units/quiz')

const Sponsors = () => import('@/views/Sponsors/sponsors')
const Sponsor = () => import('@/views/Sponsors/sponsor')

const Sections = () => import('@/views/Sections/sections')
const Section = () => import('@/views/Sections/section')

const SubscribedUsers = () => import('@/views/SubscribedUsers/subscribedCourseUsers')
const SubscribedClassUsers = () => import('@/views/SubscribedUsers/subscribedClassUsers')

const UserSubscribs= ()=>import('@/views/myUsers/userSubscribs')
Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes () {
  return [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: TheContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        
        {
          path: 'categories',
          name: 'Categories',
          component: Categories
        },
        {
          path: 'category/:id',
          name: 'Category',
          component: Category
        },
        {
          path: 'category/:id/:mode',
          name: 'ViewCategory',
          component: Category
        },
        {
          path: 'category',
          meta: {
            label: 'New Category'
          },
          
          name: 'New Category',
          component: Category
        },
        {
          path: 'streams',
          name: 'Streams',
          component: Streams
        },
        {
          path: 'stream/:courseStreamId',
          name: 'Stream',
          component: Stream
        },
        {
          path: 'stream/:mode',
          meta: {
            label: 'New Stream'
          },
          name: 'NewStream',
          component: Stream
        },
        {
          path: 'stream/:streamId/:mode',
          meta: {
            label: 'View Stream'
          },
          name: 'ViewStream',
          component: Stream
        },

        {
          path: 'grades',
          name: 'Grades',
          component: Grades
        },
        {
          path: 'grade/:gradeId',
          name: 'Grade',
          component: Grade
        },
        {
          path: 'grade/:gradeId/:mode',
          name: 'ViewGrade',
          component: Grade
        },
       
        {
          path: 'grade/:mode',
          meta: {
            label: 'New Grade'
          },
          name: 'New Grade',
          component: Grade
        }, 
        {
          path: 'course',
          meta: {
            label: 'New Course'
          },
          name: 'New Course',
          component: Course
        }, 
        {
          path: 'courses',
          meta: {
            label:"All Subjects"
          },
          component: {
            render (c) { return c('router-view') }
          },
          children:[
            {
              path: '',
              meta: {
                label:"Subjects"
              },
              name: 'Courses',
              component: Courses,
            },
            {
              path: 'course/:courseId',
              meta: {
                label: 'Course'
              },
              name: 'Course',
              component: Course,
            },
            {
              path: 'units/:sectionId/:courseId',
              meta: {
                label: 'Lessons'
              },
              name: 'Units',
              component: Units
            },
            {
              path: 'unit/:unitId/:sectionId/:courseId',
              meta: {
                label: 'Lesson'
              },
              name: 'Unit',
              component: Unit
            },
            {
              path: 'unit/:unitId/:sectionId/:courseId/:mode',
              meta: {
                label: 'Lesson'
              },
              name: 'ViewUnit',
              component: Unit
            },
            {
              path: 'unit/:sectionId/:courseId',
              meta: {
                label: 'New Lesson'
              },
              name: 'NewTopic',
              component: Unit
            },
          ]
        },
        {
          path: '/courses/course/new/:mode',
          meta: {
            label: 'New Subject'
          },
          name: 'NewCourse',
          component: Course
        },
        {
          path: '/courses/course/:courseId/:mode',
          meta: {
            label: 'Subject Details'
          },
          name: 'ViewCourse',
          component: Course
        },
        {
          path: 'course/:courseId',
          meta: {
            label: 'Subject'
          },
          name: 'Course',
          component: Course
        },




        {
          path: 'classes',
          name: 'Classes',
          component: Classes
        },
        
         

        {
          path: '/classes/class/:mode',
          meta: {
            label: 'New Class'
          },
          name: 'NewClass',
          component: Class
        },
        {
          path: '/classes/class/:classId/:mode',
          meta: {
            label: ' Class Details'
          },
          name: 'ViewClass',
          component: Class
        },
        {
          path: 'class/:classId',
          name: 'Class',
          component: Class
        },

        {
          path: '/courses/course/new/:mode',
          meta: {
            label: 'New Unit'
          },
          name: 'NewSection',
          component: Section
        },
        {
          path: '/section/:sectionId/:courseId/:mode',
          meta: {
            label: 'Unit Details'
          },
          name: 'ViewSection',
          component: Section
        },
        {
          path: 'section/:sectionId/:courseId',
          name: 'Section',
          meta: {
            label: 'Unit Details'
          },
          component: Section
        },
        {
          path: 'sections/:courseId',
          name: 'Sections',
          meta: {
            label: 'Units'
          },
          component: Sections
        },
        {
          path: 'quizs/:unitId/:sectionId/:courseId',
          name: 'Quizs',
          component: Quizs
        },
        {
          path: 'quiz/:questionId/:unitId/:sectionId/:courseId',
          meta: {
            label: 'Quiz'
          },
          name: 'Quiz',
          component: Quiz
        },
        {
          path: 'quiz/:unitId/:sectionId/:courseId',
          meta: {
            label: 'New Quiz'
          },
          name: 'New Question',
          component: Quiz
        },
        

        {
          path: 'Sponsors',
          name: 'Sponsors',
          component: Sponsors
        },
        {
          path: '/Sponsors/Sponsor/:mode',
          meta: {
            label: 'New Sponsor'
          },
          name: 'NewSponsor',
          component: Sponsor
        },
        {
          path: '/Sponsors/Sponsor/:sponsorId/:mode',
          meta: {
            label: ' Sponsor Details'
          },
          name: 'ViewSponsor',
          component: Sponsor
        },
        {
          path: 'Sponsor/:sponsorId',
          name: 'Sponsor',
          component: Sponsor
        },
       
        {
          path: 'subscribedUsers/:courseId',
          meta: {
            label: 'Subscription Users'
          },
          name: 'SubscribedUsers',
          component: SubscribedUsers
        },
        {
          path: 'subscribedClassUsers/:classId',
          meta: {
            label: 'Subscribed Users'
          },
          name: 'SubscribedClassUsers',
          component: SubscribedClassUsers
        },
        {
          path: 'appusers',
          meta: {
            label: 'App Users'
          },
          name: 'AppUsers',
          component: AppUsers
        },
        {
          path: 'appuser/:uid',
          meta: {
            label: 'App User'
          },
          name: 'AppUser',
          component: AppUser
        },
        {
          path: 'userSubscribs/:uid',
          meta: {
            label: 'User Subscriptions'
          },
          name: 'UserSubscribs',
          component:UserSubscribs
        },
        {
          path: 'Cmsusers',
          meta: {
            label: 'CMS Users'
          },
          name: 'CMSUsers',
          component: CMSUsers
        },
        {
          path: 'Cmsuser',
          meta: {
            label: 'CMS User'
          },
          name: 'CMSUser',
          component: CMSUser
        },
        {
          path: 'users',
          meta: {
            label: 'Users'
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '',
              name: 'Users',
              component: Users
            },
            {
              path: ':id',
              meta: {
                label: 'User Details'
              },
              name: 'User',
              component: User
            },
            
          ]
        },

       
      ]
    },
    {
      path: '/auth',
      redirect: '/pages/404',
      name: 'Login',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: 'login',
          name: 'Login',
          component: Login
        }
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        
        {
          path: 'register',
          name: 'Register',
          component: Register
        }
      ]
    }
  ]
}

